export default __webpack_public_path__ + "static/media/mercado-municipal-de-curitiba.d7c8a168.jpg";